import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

// Layout
import Layout from './components/layout/Layout';

// Pages
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import PipelineOverview from './pages/Pipeline/PipelineOverview';
import PipelineStage from './pages/Pipeline/PipelineStage';
import OperatingModel from './pages/OperatingModel';
import SLACatalogueOverview from './pages/SLA/SLACatalogueOverview';
import SLADetail from './pages/SLA/SLADetail';
import RolesOverview from './pages/Roles/RolesOverview';
import RoleDetail from './pages/Roles/RoleDetail';
import SOPsOverview from './pages/SOPs/SOPsOverview';
import SOPDetail from './pages/SOPs/SOPDetail';
import PoliciesOverview from './pages/Policies/PoliciesOverview';
import PolicyDetail from './pages/Policies/PolicyDetail';
import PerformanceOverview from './pages/Performance/PerformanceOverview';
import KPIFramework from './pages/Performance/KPIFramework';
import Scorecards from './pages/Performance/Scorecards';
import ImplementationOverview from './pages/Implementation/ImplementationOverview';
import ImplementationPhase from './pages/Implementation/ImplementationPhase';
import ImplementationTracker from './pages/Implementation/ImplementationTracker';
import CRMConfiguration from './pages/CRM/CRMConfiguration';
import TrainingResources from './pages/Training/TrainingResources';
import ToolsTemplates from './pages/Tools/ToolsTemplates';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set document direction based on language
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Router>
      <Layout>
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Dashboard */}
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Lead Management Pipeline */}
          <Route path="/pipeline" element={<PipelineOverview />} />
          <Route path="/pipeline/stage/:stageId" element={<PipelineStage />} />
          <Route path="/operating-model" element={<OperatingModel />} />
          <Route path="/sla-catalogue" element={<SLACatalogueOverview />} />
          <Route path="/sla-catalogue/:type/:id" element={<SLADetail />} />
          {/* Legacy route redirect */}
          <Route path="/sla-catalog" element={<SLACatalogueOverview />} />

          {/* Roles & Responsibilities */}
          <Route path="/roles" element={<RolesOverview />} />
          <Route path="/roles/:roleId" element={<RoleDetail />} />

          {/* SOPs */}
          <Route path="/sops" element={<SOPsOverview />} />
          <Route path="/sops/:sopId" element={<SOPDetail />} />

          {/* Policies */}
          <Route path="/policies" element={<PoliciesOverview />} />
          <Route path="/policies/:policyId" element={<PolicyDetail />} />

          {/* Performance Management */}
          <Route path="/performance" element={<PerformanceOverview />} />
          <Route path="/performance/kpis" element={<KPIFramework />} />
          <Route path="/performance/scorecards" element={<Scorecards />} />

          {/* Implementation Guide */}
          <Route path="/implementation" element={<ImplementationOverview />} />
          <Route path="/implementation/phase/:phaseId" element={<ImplementationPhase />} />
          <Route path="/implementation/tracker" element={<ImplementationTracker />} />

          {/* CRM Configuration */}
          <Route path="/crm" element={<CRMConfiguration />} />

          {/* Training & Resources */}
          <Route path="/training" element={<TrainingResources />} />

          {/* Tools & Templates */}
          <Route path="/tools" element={<ToolsTemplates />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
